export default __webpack_public_path__ + "static/media/supplier_img.a517808a.gif";